<div class="header">
  <div class="container d-flex align-items-center">
    <div class="header-logo">
      <a href="">
        <img src="assets/park-advertising-logo.png" width="160">
      </a>
    </div>
  </div>
</div>

<!--
=====================
QUOTE APPROVAL SCREEN
=====================
-->
<ng-container *ngIf="status === approvalStatus.PENDING_APPROVAL">
  <ng-container *ngTemplateOutlet="caseContactDetails"></ng-container>
  <div class=" container mt-4 border rounded font-weight-bold text-white px-5 py-3 total-quote">
    <div>Total Quote</div>
    <div>{{case?.totalQuote | currency}}</div>
  </div>
  <form #form="ngForm" >
    <div class="container mt-4 p-0">
      <div class="p-4 border rounded bg-white">
        <div class="row form-group">
          <div class="col-6">
            <label>Approver Name</label>
            <input
              required
              type="text"
              class="form-control"
              name="name"
              [(ngModel)]="approverDetails.name">
          </div>
          <div class="col-6">
            <label>Approver Email</label>
            <input
              required
              type="email"
              class="form-control"
              name="email"
              appValidEmailValidator
              [(ngModel)]="approverDetails.email">
          </div>
        </div>
        <div class="row form-group">
          <div class="col">
            <label>Approval Note</label>
            <textarea
              required
              cols="30"
              rows="10"
              class="form-control"
              name="note"
              [(ngModel)]="approverDetails.note"></textarea>
          </div>
        </div>
        <div class="row form-group">
          <div class="col">
            <p-checkbox
              required
              binary="true"
              name="confirmDetails"
              inputId="confirmDetails"
              [(ngModel)]="approverDetails.confirmDetails">
            </p-checkbox>
            <label for="confirmDetails" class="checkbox-label font-weight-bold">
              I confirm that I have reviewed the quote for accuracy. Approving will notify the Park team of your response to move the case forward.</label>
          </div>
        </div>
      </div>
    </div>

    <div class="container mt-4 p-0">
      <div class="alert alert-warning d-flex align-items-center">
        <i class="fas fa-lg fa-exclamation-triangle text-warning mr-2"></i>
        <div class="text-dark font-weight-semibold">Do not approve if the quote needs revisions.</div>
      </div>
    </div>

    <div class="container mt-4 p-0" *ngIf="hasExistingAccount">
      <div class="alert alert-light d-flex align-items-center">
        <i class="fa fa-info-circle mr-2"></i>
        <div class="span text-dark">
          If you want to know more information or request revisions for this quote, please login to continue. You may
          reach out to the Case Contact if you have no login credentials.</div>
        <button class="btn btn-outline-primary btn-sm ml-auto" (click)="navigateToLogin()">Login</button>
      </div>
    </div>

    <div class="container mt-4 p-0" *ngIf="!hasExistingAccount">
      <div class="alert alert-light d-flex align-items-center">
        <i class="fa fa-info-circle mr-2"></i>
        <div class="span text-dark">
          Reply to email to request revisions.</div>
      </div>
    </div>

    <div class="container mt-4 p-0">
      <button
        class="btn btn-primary btn-lg text-uppercase"
        [disabled]="form.invalid || !approverDetails.confirmDetails"
        (click)="approve(form)">
        Approve quote
      </button>
    </div>
  </form>
</ng-container>

<!--
========================
QUOTE APPROVED - SCREEN
========================
-->

<ng-container *ngIf="status === approvalStatus.APPROVED">
  <!-- quote approve banner -->
  <div class="container mt-4 px-0">
    <div class="border bg-white rounded text-center p-4" style="border-color: #61912B !important">
      <i class="fa fa-check-circle text-primary" style="font-size: 96px;"></i>
      <h4 class="mt-4 text-primary">This quote has been approved!</h4>
    </div>
  </div>

  <div class="container mt-4 border bg-white rounded">
    <div class="p-4">
      <div class="panel-title">Approver Details</div>
      <div class="row mt-3">
        <div class="col-6">
          <div class="text-muted mb-1">Approver Name</div>
          <div class="font-weight-bold">{{case?.approver?.name}}</div>
        </div>
        <div class="col-6">
          <div class="text-muted mb-1">Approval Email</div>
          <div class="font-weight-bold">{{case?.approver?.email}}</div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <div class="text-muted mb-1">Approver Note</div>
          <div class="font-weight-bold">{{case?.approvalNote?.messageBody}}</div>
        </div>
        <div class="col-6">
          <div class="text-muted mb-1">Approval Date</div>
          <div>{{case?.approvalNote?.creationDate | date: 'MMMM d, y hh:mm z'}}</div>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngTemplateOutlet="caseContactDetails"></ng-container>
  <div class=" container mt-4 border rounded font-weight-bold text-white px-5 py-3 total-quote">
    <div>Total Quote</div>
    <div>{{case?.totalQuote | currency}}</div>
  </div>

</ng-container>


<!--
===============================
QUOTE PENDING REVISION - SCREEN
===============================
-->

<ng-container *ngIf="status === approvalStatus.REVISION">
  <div class="container mt-4 px-0">
    <div class="border bg-white rounded text-center p-4">
      <img src="assets/images/icon-warning-circle.svg" title="Pending Quote Revision" />
      <h4 class="pending-quote-title mt-4">Pending Quote Revision</h4>
      <p class="pending-quote-message mt-3">
        You will get notified when Park Advertisements<br/>sends you the revised quote for approval.
      </p>
    </div>
  </div>
  <ng-container *ngTemplateOutlet="caseContactDetails"></ng-container>
</ng-container>

<!--
===============================
ON HOLD - SCREEN
===============================
-->

<ng-container *ngIf="status === approvalStatus.ON_HOLD">
  <div class="container mt-4 px-0">
    <div class="border bg-white rounded text-center p-4">
      <img src="assets/images/stage-icons/on-hold-quote-approval.svg" title="On Hold" />
      <h4 class="pending-quote-title mt-4">Case is On Hold</h4>
      <p class="pending-quote-message mt-3">
        You will get notified when Case is resumed.
      </p>
    </div>
  </div>
  <ng-container *ngTemplateOutlet="caseContactDetails"></ng-container>
</ng-container>

<ng-template #caseContactDetails>
  <div class="container mt-4">
    <div class="row p-4 border bg-white rounded">
      <div class="col-3">
        <div class="font-weight-bold item-title">Case Number</div>
        <div class="case-number">{{case?.caseNumber}}</div>
      </div>
      <div class="col-3">
        <div class="text-uppercase item-title text-muted">Request Date</div>
        <div class="font-weight-bold">{{case?.requestDate | date}}</div>
      </div>
    </div>
  </div>

  <div class="container mt-4 border bg-white rounded">
    <div class="p-4">
      <div class="panel-title">Case Quote Details</div>
      <div class="row mt-3">
        <div class="col-6">
          <div class="text-muted mb-1">Project Manager</div>
          <div class="font-weight-bold">{{case?.projectManager | fullName}}</div>
        </div>
        <div class="col-6">
          <div class="text-muted mb-1">Case Contact</div>
          <div class="font-weight-bold">{{case?.caseContact | fullName}}</div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <div class="text-muted mb-1">End Client</div>
          <div class="font-weight-bold">{{case?.endClient?.name}}</div>
        </div>
        <div class="col-6">
          <div class="text-muted mb-1">Job Title & Reference Number:</div>
          <ng-container *ngIf="case?.jobTitleRefNumber.length > 0">
            <span class="job-title-reference-badge mr-2" *ngFor="let job of case.jobTitleRefNumber">
              {{job}}
            </span>
          </ng-container>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-6">
          <div class="text-muted mb-1">Location</div>
          <div class="font-weight-bold">
            {{case?.location?.city}}, {{case?.location?.district}}, {{case?.location?.postalCode}}
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<footer class="cqa-footer mt-4 py-4 text-white">
  <div class="container d-flex justify-content-between">
    <div>
      Copyright - 2024 Park Firm | All Rights Reserved
    </div>
    <div>
      Privacy and Data Protection Policy
    </div>
    <div>
      <a href="https://www.linkedin.com/company/park-advertising">
        <img src="assets\images\misc-icons\icon-linkedin-square.svg"/>
      </a>
    </div>
  </div>
</footer>
